const defaultSchool = {
  name: "Johnny's Martial Arts",
  style: "Martial Arts",
  shortName: "Johnny's",
  tagline: "Build confidence. Get fit. Learn skills that last.",
  positioning: "A welcoming Brookhaven school where kids, teens, adults, and families build capability together.",
  city: "Brookhaven",
  state: "Georgia",
  stateCode: "GA",
  establishedYear: 2008,
  monogram: "J✳A",
  zip: "30319",
  address: "1000 Demo Mat Way NE",
  addressLine: "1000 Demo Mat Way NE, Brookhaven, GA 30319",
  phone: "(404) 555-0198",
  phoneHref: "tel:+14045550198",
  email: "hello@johnnysmartialarts.example",
  emailHref: "mailto:hello@johnnysmartialarts.example",
  hours: [
    { days: "Monday–Thursday", hours: "6:30 AM–8:30 PM" },
    { days: "Friday", hours: "6:30 AM–6:30 PM" },
    { days: "Saturday", hours: "8:00 AM–2:00 PM" },
    { days: "Sunday", hours: "Closed for recovery" },
  ],
  socialLinks: [
    { label: "Instagram", href: "https://johnnysmartialarts.example/instagram" },
    { label: "Facebook", href: "https://johnnysmartialarts.example/facebook" },
  ],
  mapUrl: "https://www.google.com/maps/search/?api=1&query=1000+Demo+Mat+Way+NE+Brookhaven+GA+30319",
  freeWeekOffer: {
    eyebrow: "A low-pressure first step",
    title: "Try one week. See if it fits.",
    description: "Come meet the coaches, move through a real class, and decide with no pressure.",
    reassurance: "No experience needed. No obligation. Just come try it.",
  },
  reviewProof: {
    rating: "4.9",
    count: "175+",
    label: "Local Families",
    source: "Google rating",
    stars: "★★★★★",
  },
  seo: {
    defaultTitle: "Johnny's Martial Arts | Brookhaven, Georgia",
    defaultDescription: "Welcoming martial arts classes in Brookhaven, Georgia for kids, teens, adults, and families. Start with a free week pass.",
  },
  images: {
    hero: "https://images.unsplash.com/photo-1555597408-26bc8e548a46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxtYXJ0aWFsJTIwYXJ0cyUyMGRpc2NpcGxpbmUlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODc5MTkyNzZ8MA&ixlib=rb-4.1.0&q=85&w=1600",
    youth: "https://images.unsplash.com/photo-1583668023935-b79e1c1af0a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxjaGlsZHJlbiUyMG1hcnRpYWwlMjBhcnRzJTIwZm9jdXMlMjBrYXJhdGV8ZW58MHx8fHwxNzg3OTE5Mjg1fDA&ixlib=rb-4.1.0&q=85&w=1600",
    adult: "https://images.unsplash.com/photo-1514050566906-8d077bae7046?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxtYXJ0aWFsJTIwYXJ0cyUyMGRpc2NpcGxpbmUlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODc5MTkyNzZ8MA&ixlib=rb-4.1.0&q=85&w=1600",
    community: "https://images.unsplash.com/photo-1555597673-b21d5c935865?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxtYXJ0aWFsJTIwYXJ0cyUyMGRpc2NpcGxpbmUlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODc5MTkyNzZ8MA&ixlib=rb-4.1.0&q=85&w=1600",
    belt: "https://images.unsplash.com/photo-1603210185246-b1662978ea37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NjA1NjZ8MHwxfHNlYXJjaHw0fHx0YWVrd29uZG8lMjBraWRzJTIwYWR1bHQlMjBkb2pvJTIwYmxhY2slMjBiZWx0fGVufDB8fHx8MTc4NzkxOTI3Nnww&ixlib=rb-4.1.0&q=85&w=1600",
    instructor: "https://images.unsplash.com/photo-1541836567455-2d41eb6dd9b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMG1hcnRpYWwlMjBhcnRzJTIwZm9jdXMlMjBrYXJhdGV8ZW58MHx8fHwxNzg3OTE5Mjg1fDA&ixlib=rb-4.1.0&q=85&w=1600",
    pair: "https://images.unsplash.com/photo-1579331844418-fcd67e29b3d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxjaGlsZHJlbiUyMG1hcnRpYWwlMjBhcnRzJTIwZm9jdXMlMjBrYXJhdGV8ZW58MHx8fHwxNzg3OTE5Mjg1fDA&ixlib=rb-4.1.0&q=85&w=1600",
  },
  benefits: [
    { number: "01", title: "Confidence", text: "Small, practiced wins help students speak up, try again, and trust themselves." },
    { number: "02", title: "Discipline", text: "A clear routine turns effort into a habit students can carry into school and work." },
    { number: "03", title: "Focus", text: "Breath, balance, and simple repetition give busy minds somewhere to land." },
    { number: "04", title: "Fitness", text: "Move, sweat, and build coordination without needing to arrive in shape." },
    { number: "05", title: "Self-defense", text: "Learn practical awareness and calm responses in a supportive setting." },
    { number: "06", title: "Community", text: "Train beside people who celebrate progress instead of comparing performance." },
  ],
  manifesto: [
    { number: "01", title: "Start with stillness", text: "The first lesson is not how hard to hit. It is how to notice your breath, your balance, and the mat around you." },
    { number: "02", title: "Practice makes progress", text: "A thoughtful curriculum gives energy a direction, turning busy bodies and busy minds into capable ones." },
    { number: "03", title: "Progress is shared", text: "Parents, children, and adult students all learn in public. We make space for the brave awkwardness of beginning." },
    { number: "04", title: "Bring it home", text: "The best class changes more than a class. It becomes patience at homework time, steadiness in a hard conversation, and pride in showing up." },
  ],
  programs: [
    {
      slug: "kids-martial-arts",
      name: "Kids Martial Arts",
      kicker: "Ages 6–12",
      audience: "For kids who are ready to move, make friends, and feel more sure of themselves.",
      summary: "Help your child build confidence, focus, discipline, and skills they can carry beyond the mat.",
      description: "Our kids martial arts program gives growing students a positive place to practice listening, coordination, respect, and self-defense. Classes are energetic without being chaotic, with clear routines that help both outgoing and shy children find their footing.",
      image: "youth",
      benefits: ["Confidence in new situations", "Better focus and listening", "Coordination and healthy fitness", "Respectful self-defense habits"],
      learn: ["Stance, balance, and safe movement", "How to use a calm voice and clear boundaries", "Partner drills built around control and respect", "How to set a goal and keep practicing"],
      classFeel: "Expect a warm welcome, a short focus ritual, skill games, partner practice, and a proud high-five at the end. Parents can watch without hovering.",
      metaTitle: "Kids Martial Arts in Brookhaven, GA",
      metaDescription: "Kids martial arts in Brookhaven, Georgia for ages 6–12. Build confidence, focus, fitness, and respectful self-defense skills in a welcoming class.",
      related: ["family-martial-arts", "teen-martial-arts"],
    },
    {
      slug: "teen-martial-arts",
      name: "Teen Martial Arts",
      kicker: "Ages 13–17",
      audience: "For teens who want a challenge, a positive circle, and a stronger sense of what they can do.",
      summary: "A practical training environment for confidence, fitness, self-defense, and personal direction.",
      description: "Teen years ask students to navigate pressure, change, and social noise. Our teen martial arts classes offer a grounded place to work hard, build real friendships, and learn skills that make confidence feel earned rather than performed.",
      image: "pair",
      benefits: ["Functional fitness and stamina", "Practical self-defense awareness", "Positive friendships and accountability", "Calm under pressure"],
      learn: ["Footwork, distance, and safe partner work", "Strength and conditioning that meets beginners where they are", "How to respond instead of react", "Leadership through helping newer students"],
      classFeel: "Sessions balance technical practice with a physical challenge. Coaches are direct, kind, and invested in helping teens take ownership of their progress.",
      metaTitle: "Teen Martial Arts in Brookhaven, GA",
      metaDescription: "Teen martial arts classes in Brookhaven, Georgia for confidence, fitness, self-defense, and positive personal development.",
      related: ["kids-martial-arts", "adult-martial-arts"],
    },
    {
      slug: "adult-martial-arts",
      name: "Adult Martial Arts",
      kicker: "Beginners welcome",
      audience: "For adults who want to move well, feel capable, and learn something worth returning to.",
      summary: "A focused, friendly practice for fitness, self-defense, stress relief, and lifelong learning.",
      description: "You do not need a fighter's background or a perfect schedule to begin. Adult martial arts at Johnny's pairs clear instruction with a welcoming pace, so you can build fitness and practical skill while leaving the workday behind for an hour.",
      image: "adult",
      benefits: ["Full-body fitness without the gym grind", "Practical self-defense fundamentals", "Stress relief through focused movement", "A community that remembers your name"],
      learn: ["Foundational strikes, movement, and defensive habits", "How to train safely with different partners", "Mobility, conditioning, and recovery basics", "How to keep learning without rushing the process"],
      classFeel: "Arrive as you are. Coaches offer options for different bodies and starting points, then guide you through a satisfying blend of technique, conditioning, and reset.",
      metaTitle: "Adult Martial Arts in Brookhaven, GA",
      metaDescription: "Beginner-friendly adult martial arts in Brookhaven, Georgia for fitness, self-defense, stress relief, and confidence.",
      related: ["teen-martial-arts", "brazilian-jiu-jitsu", "kickboxing"],
    },
    {
      slug: "family-martial-arts",
      name: "Family Martial Arts",
      kicker: "Train together",
      audience: "For families who want a healthy ritual they can share, not another activity to divide up.",
      summary: "A welcoming way for parents and children to learn, laugh, and progress on the same mat.",
      description: "Family martial arts turns practice into time together. Adults and kids work at an appropriate level, encourage each other, and discover that progress looks different for everyone—even when you leave class through the same door.",
      image: "community",
      benefits: ["A screen-free family ritual", "Shared goals and encouragement", "Movement for multiple ages", "Confidence built side by side"],
      learn: ["Simple drills families can practice safely", "How to give useful encouragement", "Balance, coordination, and body awareness", "How to celebrate effort rather than rank"],
      classFeel: "Classes are playful, organized, and adaptable. A coach keeps the class moving while giving each family member a meaningful challenge.",
      metaTitle: "Family Martial Arts in Brookhaven, GA",
      metaDescription: "Family martial arts in Brookhaven, Georgia for parents and children who want to build fitness, confidence, and connection together.",
      related: ["kids-martial-arts", "adult-martial-arts"],
    },
    {
      slug: "brazilian-jiu-jitsu",
      name: "Brazilian Jiu-Jitsu",
      kicker: "Specialty program",
      audience: "For teens and adults interested in leverage, problem-solving, and grounded self-defense.",
      summary: "A technical practice that rewards patience, curiosity, and calm problem-solving.",
      description: "Our Brazilian Jiu-Jitsu program introduces the art of position, leverage, and controlled partner work. It is challenging in the best way: every round asks you to listen, adapt, and keep your breathing steady.",
      image: "adult",
      benefits: ["Grounded self-defense concepts", "Problem-solving under pressure", "Grip, core, and full-body strength", "A patient, technical community"],
      learn: ["Position, posture, and safe transitions", "How leverage changes the equation", "Controlled rounds with clear boundaries", "How to tap, reset, and keep learning"],
      classFeel: "Expect detail, repetition, and a lot of thoughtful questions. Beginners get a clear path onto the mat, with no assumption that you already know the vocabulary.",
      metaTitle: "Brazilian Jiu-Jitsu in Brookhaven, GA",
      metaDescription: "Beginner-friendly Brazilian Jiu-Jitsu in Brookhaven, Georgia for practical self-defense, fitness, and technical problem-solving.",
      related: ["adult-martial-arts", "kickboxing"],
    },
    {
      slug: "kickboxing",
      name: "Kickboxing",
      kicker: "Specialty program",
      audience: "For adults and teens who want an upbeat, coach-led workout with real skill behind it.",
      summary: "A crisp, rhythmic class that builds stamina, coordination, and confident movement.",
      description: "Kickboxing at Johnny's is a skill-first workout: combinations are taught clearly, rounds are scaled thoughtfully, and every student gets to work at a sustainable pace. Come for the sweat; stay for the feeling of getting sharper.",
      image: "adult",
      benefits: ["Cardio that does not feel repetitive", "Coordination and timing", "Stress release through purposeful effort", "A scalable path for beginners"],
      learn: ["Safe striking mechanics and footwork", "How to pace rounds and recover well", "Combinations that challenge memory and movement", "How to train hard without training recklessly"],
      classFeel: "Music stays supportive, coaching stays personal, and the dojo makes space for first-timers. You will leave tired, clearer, and glad you came.",
      metaTitle: "Kickboxing Classes in Brookhaven, GA",
      metaDescription: "Beginner-friendly kickboxing classes in Brookhaven, Georgia for fitness, coordination, stress relief, and confident movement.",
      related: ["adult-martial-arts", "brazilian-jiu-jitsu"],
    },
  ],
  instructors: [
    {
      slug: "johnny-vance",
      name: "Johnny Vance",
      role: "Founder & Head Instructor",
      credential: "32 years of practice · Youth mentor",
      image: "instructor",
      bio: "Johnny started teaching because he wanted students to experience the steadiness that training gave him. His classes are clear, warm, and quietly demanding in the right ways.",
      quote: "We are not here to make people intimidating. We are here to help them feel at home in their own capability.",
    },
    {
      slug: "elena-ross",
      name: "Elena Ross",
      role: "Youth Program Director",
      credential: "Exercise science · Kids coach",
      image: "youth",
      bio: "Elena is known for noticing the student who needs one more explanation and the student who needs one more chance to lead. Her coaching is structured, energetic, and kind.",
      quote: "When a child learns to balance on their own foot, their confidence starts to travel with them.",
    },
    {
      slug: "marcus-bennett",
      name: "Marcus Bennett",
      role: "Adult & Specialty Coach",
      credential: "BJJ brown belt · Movement specialist",
      image: "adult",
      bio: "Marcus makes technical training approachable. He helps adults understand the why behind each movement, then gives them the space to make it their own.",
      quote: "The mat is a rare place where the next hour gets to be about one useful thing at a time.",
    },
  ],
  testimonials: [
    { quote: "My son was nervous about trying martial arts. After the first class he asked when he could go back. Now he volunteers to demonstrate at school.", name: "Maya R.", context: "Parent of a 9-year-old", rating: "5.0" },
    { quote: "I had never done martial arts and expected to feel out of place. The coach gave me options, explained everything, and I left feeling like I could come back.", name: "Andre T.", context: "Adult student", rating: "5.0" },
    { quote: "Family class became our favorite Saturday ritual. We all work at a different level, but we leave feeling like we did something together.", name: "Priya & Noah K.", context: "Family students", rating: "5.0" },
    { quote: "My daughter has started trying homework before asking if it will be hard. She is still seven, but that little change has meant a lot at home.", name: "Jordan L.", context: "Parent of a 7-year-old", rating: "5.0" },
  ],
  faqs: [
    { question: "I've never done martial arts before. Can I still join?", answer: "Absolutely. Every program has a clear on-ramp for beginners, and coaches explain the language, movement, and expectations as you go." },
    { question: "Does my child need to be athletic?", answer: "No. Coordination and fitness are built in class. Coaches scale activities to the student in front of them, so a shy or uncoordinated beginner has a real place to start." },
    { question: "What should I wear to the first class?", answer: "Wear comfortable athletic clothes and bring water. You can train without a uniform during your Free Week while you decide if the school feels right." },
    { question: "Is martial arts safe for kids?", answer: "We teach control, awareness, and respectful partner work before intensity. Coaches scale activities to age and experience, and students learn how to stop and reset." },
    { question: "What age can children start?", answer: "Our main kids program is designed for ages 6–12. Family classes can include younger children when a coach confirms the format is a good fit." },
    { question: "Do I need to be in shape to start?", answer: "Not at all. You start with the body and energy you have today. Training scales up as your comfort, coordination, and conditioning grow." },
    { question: "What happens during my Free Week?", answer: "We welcome you, show you around, help you choose the right class, and guide you through a beginner-friendly session. There is no pressure to sign up on the spot." },
    { question: "Do I have to sign a contract to get the Free Week?", answer: "No. The Free Week is simply a chance to experience the school. There is no contract or obligation attached to claiming it." },
    { question: "Can parents and children train together?", answer: "Yes. Family Martial Arts gives parents and children a shared class, while age-specific sessions let each student work at an appropriate pace." },
  ],
  schedule: {
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Saturday"],
    categories: ["All", "Kids", "Teens & Adults", "Family"],
    classes: [
      { id: "mon-kids", day: "Monday", time: "4:30 PM", name: "Kids Martial Arts", category: "Kids", ages: "6–12", level: "Beginners welcome", spots: "4 spots open" },
      { id: "mon-adult", day: "Monday", time: "6:30 PM", name: "Adult Martial Arts", category: "Teens & Adults", ages: "13+", level: "All levels", spots: "6 spots open" },
      { id: "tue-family", day: "Tuesday", time: "5:30 PM", name: "Family Martial Arts", category: "Family", ages: "6+ with adult", level: "All levels", spots: "5 spots open" },
      { id: "tue-kickboxing", day: "Tuesday", time: "7:00 PM", name: "Kickboxing", category: "Teens & Adults", ages: "13+", level: "Beginner friendly", spots: "7 spots open" },
      { id: "wed-teen", day: "Wednesday", time: "5:30 PM", name: "Teen Martial Arts", category: "Teens & Adults", ages: "13–17", level: "All levels", spots: "3 spots open" },
      { id: "wed-bjj", day: "Wednesday", time: "7:00 PM", name: "Brazilian Jiu-Jitsu", category: "Teens & Adults", ages: "13+", level: "Beginner friendly", spots: "5 spots open" },
      { id: "thu-kids", day: "Thursday", time: "4:30 PM", name: "Kids Martial Arts", category: "Kids", ages: "6–12", level: "Beginners welcome", spots: "4 spots open" },
      { id: "thu-adult", day: "Thursday", time: "6:30 PM", name: "Adult Martial Arts", category: "Teens & Adults", ages: "18+", level: "All levels", spots: "6 spots open" },
      { id: "sat-family", day: "Saturday", time: "9:30 AM", name: "Family Martial Arts", category: "Family", ages: "6+ with adult", level: "All levels", spots: "8 spots open" },
      { id: "sat-open", day: "Saturday", time: "11:00 AM", name: "Open Mat & Skills", category: "Teens & Adults", ages: "13+", level: "Invite / Free Week", spots: "5 spots open" },
    ],
  },
};

function runtimeImageValue(value, fallback) {
  if (typeof value === "string") return value || fallback;
  return value?.url || value?.src || fallback;
}

function runtimeImages(value, configured = false) {
  const images = configured ? {} : { ...defaultSchool.images };
  const keys = ["hero", "about", "outcomes", "youth", "adult", "community", "cta", "map", "instructor", "pair", "belt"];
  const assign = (key, item) => {
    const resolved = runtimeImageValue(item, images[key]);
    if (key && resolved) images[key] = resolved;
  };
  if (Array.isArray(value)) {
    value.forEach((item, index) => assign(item?.key || keys[index], item));
  } else if (value && typeof value === "object") {
    Object.entries(value).forEach(([key, item]) => assign(key, item));
  }
  return images;
}

function runtimeImageKey(value, images, fallback) {
  const candidate = typeof value === "object" ? runtimeImageValue(value, "") : value;
  if (!candidate) return fallback;
  if (images[candidate]) return candidate;
  if (/^https?:\/\//i.test(candidate)) {
    const key = `runtime-${Object.keys(images).length}`;
    images[key] = candidate;
    return key;
  }
  return fallback;
}

function programFallback(source) {
  const clues = [source.slug, source.name, source.title, source.kicker, source.ageRange, source.ages, source.category].filter(Boolean).join(" ").toLowerCase();
  if (/(family|parent|together)/.test(clues)) return defaultSchool.programs.find((program) => program.slug === "family-martial-arts") || defaultSchool.programs[0];
  if (/(kid|child|youth|tiger|preschool|6[-–]12)/.test(clues)) return defaultSchool.programs.find((program) => program.slug === "kids-martial-arts") || defaultSchool.programs[0];
  if (/(teen|13[-–]17)/.test(clues)) return defaultSchool.programs.find((program) => program.slug === "teen-martial-arts") || defaultSchool.programs[0];
  if (/(adult|18\+)/.test(clues)) return defaultSchool.programs.find((program) => program.slug === "adult-martial-arts") || defaultSchool.programs[0];
  if (/(bjj|jiu[- ]?jitsu|grappl)/.test(clues)) return defaultSchool.programs.find((program) => program.slug === "brazilian-jiu-jitsu") || defaultSchool.programs[0];
  if (/(kickbox|boxing|strik)/.test(clues)) return defaultSchool.programs.find((program) => program.slug === "kickboxing") || defaultSchool.programs[0];
  return defaultSchool.programs[0];
}

function runtimePrograms(items, images, city, state, stateCode, style, configured = false) {
  const candidates = Array.isArray(items) ? items.filter((item) => {
    const source = typeof item === "string" ? { name: item } : item || {};
    const name = source.name || source.title || "";
    return name && !/^https?:\/\//i.test(name) && !name.includes("://");
  }) : [];
  if (!candidates.length) {
    if (configured) return [];
    return [{ slug: "martial-arts-training", name: `${style} Training`, kicker: "Beginners welcome", audience: `A welcoming ${style} program for students at every level.`, summary: "Build confidence, focus, fitness, and skill through consistent training.", description: `Clear ${style} instruction for beginners and returning students who want a steady place to train.`, image: "hero", benefits: ["Confidence through consistent practice", "Focus, fitness, and coordination", "Supportive instruction for beginners", "Skills that stay useful beyond class"], learn: ["Stance, balance, and safe movement", "Foundational technique and conditioning", "How to train with control and respect", "How to keep progressing at your own pace"], classFeel: "Expect clear instruction, focused repetition, and a welcoming pace for the student in front of you.", related: [], metaTitle: `${style} Training${city ? ` in ${city}${stateCode ? `, ${stateCode}` : ""}` : ""}`, metaDescription: `${style} training${city ? ` in ${city}` : ""}${state ? `, ${state}` : ""} for beginners and all experience levels.` }];
  }
  const usedImageUrls = new Set();
  const fallbackImageKeys = ["youth", "pair", "adult", "community", "belt", "instructor", "hero"];
  return candidates.slice(0, configured ? candidates.length : 8).map((item, index) => {
    const source = typeof item === "string" ? { name: item } : item || {};
    const fallback = programFallback(source);
    const name = source.name || source.title || `${style} Training ${index + 1}`;
    const type = source.type === "event" || /\b(?:birthday|party|summer camp|spring camp|camp|event)\b/i.test(name) ? "event" : "class";
    const rawDescription = source.description || source.summary || source.audience || "";
    const summary = rawDescription && rawDescription.trim().toLowerCase() !== name.trim().toLowerCase() ? rawDescription : (configured ? "" : `A welcoming ${type === "event" ? "event" : "martial arts class"} for students ready to build skill, confidence, and steady progress.`);
    const description = rawDescription && rawDescription.trim().toLowerCase() !== name.trim().toLowerCase() ? rawDescription : (configured ? "" : summary);
    const fallbackImage = configured ? "" : fallback.image || "hero";
    let imageKey = runtimeImageKey(source.image || source.imageUrl, images, fallbackImage);
    if (!configured && usedImageUrls.has(images[imageKey])) {
      const alternate = fallbackImageKeys.find((key) => images[key] && !usedImageUrls.has(images[key]));
      if (alternate) imageKey = alternate;
    }
    if (images[imageKey]) usedImageUrls.add(images[imageKey]);
    return {
      slug: source.slug || name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || `program-${index + 1}`,
      name,
      type,
      kicker: source.kicker || (type === "event" ? "Event offering" : source.ageRange || source.ages || "Program"),
      audience: source.audience || summary,
      summary,
      description,
      martialArtsStyle: source.martialArtsStyle || source.style || "",
      image: imageKey,
      benefits: Array.isArray(source.benefits) && source.benefits.length ? source.benefits : (configured ? [] : ["Confidence through consistent practice", "Focus, fitness, and coordination", "Supportive instruction for beginners", "Skills that stay useful beyond class"]),
      learn: Array.isArray(source.learn) && source.learn.length ? source.learn : (configured ? [] : ["Stance, balance, and safe movement", "Foundational technique and conditioning", "How to train with control and respect", "How to keep progressing at your own pace"]),
      classFeel: source.classFeel || (configured ? "" : "Expect clear instruction, focused repetition, and a welcoming pace for the student in front of you."),
      related: Array.isArray(source.related) ? source.related : [],
      metaTitle: source.metaTitle || (configured ? "" : `${name}${city ? ` in ${city}${stateCode ? `, ${stateCode}` : ""}` : ""}`),
      metaDescription: source.metaDescription || (configured ? "" : `${name}${city ? ` in ${city}` : ""}${state ? `, ${state}` : ""} for beginners and all experience levels.`),
    };
  });
}

function runtimeInstructors(items, images, configured = false) {
  const fallbackItems = configured ? [{ slug: "coaching-team", name: "Coaching Team", role: "Instructors", credential: "", bio: "Meet the instructors and find a welcoming place to start.", quote: "", placeholder: true, image: "" }] : defaultSchool.instructors;
  const sourceItems = Array.isArray(items) && items.length ? items : fallbackItems;
  return (configured ? sourceItems : sourceItems.slice(0, 8)).map((item, index) => {
    const fallback = defaultSchool.instructors[index] || defaultSchool.instructors[0];
    const source = item || {};
    const sourceImage = source.image || source.imageUrl || "";
    return {
      slug: source.slug || `instructor-${index + 1}`,
      name: source.name || (configured ? "Coaching Team" : `Instructor ${index + 1}`),
      role: source.role || (configured ? "Instructors" : "Instructor"),
      credential: source.credential || "",
      bio: source.bio || (configured ? "Meet the instructors and find a welcoming place to start." : "A welcoming place to start your practice."),
      quote: source.quote || "",
      placeholder: configured ? Boolean(source.placeholder || !sourceImage) : Boolean(source.placeholder),
      image: runtimeImageKey(sourceImage, images, configured ? "" : fallback.image),
    };
  });
}

function runtimeTestimonials(items, configured = false) {
  if (!Array.isArray(items) || !items.length) {
    return configured ? [] : defaultSchool.testimonials;
  }
  return items.slice(0, 8).map((item) => {
    const source = item || {};
    return {
      quote: source.quote || source.text || "",
      name: source.name || source.author || "Local student",
      context: source.context || source.role || "Local student",
      rating: String(source.rating || "5"),
    };
  });
}

function runtimeReviewProof(items, configured = false) {
  if (!Array.isArray(items) || !items.length) {
    return configured ? { rating: "", count: "", label: "", source: "", stars: "" } : defaultSchool.reviewProof;
  }
  const ratings = items.map((item) => Number(item?.rating)).filter((value) => Number.isFinite(value) && value > 0);
  const rating = ratings.length ? (ratings.reduce((sum, value) => sum + value, 0) / ratings.length).toFixed(1) : "5.0";
  return { rating, count: String(items.length), label: items.length === 1 ? "Local student" : "Local students", source: "Community reviews", stars: "★★★★★" };
}

function runtimeSocialLinks(value) {
  if (Array.isArray(value)) return value.filter((item) => item?.href).map((item) => ({ label: item.label || "Social", href: item.href }));
  if (value && typeof value === "object") return Object.entries(value).map(([label, href]) => ({ label, href })).filter((item) => item.href);
  return [];
}

function runtimeCustomization(value) {
  if (!value || typeof value !== "object") return { brand: {}, about: {}, ctas: [], navigationLinks: [], mediaPlacements: [], assets: [], slotWarnings: [], unboundSlots: [], placeholderCount: 0 };
  const navigationLinks = Array.isArray(value.navigationLinks) ? value.navigationLinks.filter((item) => item?.label && (item.href?.startsWith("/") || item.href?.startsWith("https://"))).map((item, index) => ({ ...item, testId: `custom-nav-link-${index + 1}` })) : [];
  const mediaPlacements = Array.isArray(value.mediaPlacements) ? value.mediaPlacements.filter((item) => item?.url && (/^https?:\/\//i.test(item.url) || item.url.startsWith("/"))).map((item) => ({ ...item })) : [];
  const assets = Array.isArray(value.assets) ? value.assets.filter((item) => item?.url).map((item) => ({ ...item })) : [];
  const ctas = Array.isArray(value.ctas) ? value.ctas.filter((item) => item && (item.label || item.title)).map((item) => ({ ...item })) : [];
  const about = value.about && typeof value.about === "object" ? { ...value.about } : {};
  return { brand: value.brand && typeof value.brand === "object" ? value.brand : {}, about, ctas, navigationLinks, mediaPlacements, assets, slotWarnings: Array.isArray(value.slotWarnings) ? value.slotWarnings : [], unboundSlots: Array.isArray(value.unboundSlots) ? value.unboundSlots : [], placeholderCount: Number(value.placeholderCount || 0) };
}


function localizeData(value, tokens) {
  if (typeof value === "string") {
    const replacementYear = tokens.establishedYear || "a new chapter";
    return value
      .replaceAll("Johnny’s Martial Arts", tokens.name)
      .replaceAll("Johnny's Martial Arts", tokens.name)
      .replaceAll("Johnny’s", tokens.name)
      .replaceAll("Johnny's", tokens.name)
      .replaceAll("Johnny Vance", tokens.name)
      .replaceAll("Johnny", tokens.name)
      .replaceAll("Brookhaven", tokens.city)
      .replaceAll("brookhaven", tokens.city)
      .replaceAll("Georgia", tokens.state)
      .replace(/\bGA\b/g, tokens.stateCode)
      .replaceAll("JMA", tokens.monogram)
      .replaceAll("2008", replacementYear);
  }
  if (Array.isArray(value)) return value.map((item) => localizeData(item, tokens));
  if (value && typeof value === "object") return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, localizeData(item, tokens)]));
  return value;
}

function nameMonogram(name) {
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 3).map((part) => part[0]).join("").toUpperCase();
  return initials || "DOJO";
}

const stateNames = { AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California", CO: "Colorado", CT: "Connecticut", FL: "Florida", GA: "Georgia", IL: "Illinois", MA: "Massachusetts", MD: "Maryland", MI: "Michigan", NC: "North Carolina", NJ: "New Jersey", NY: "New York", OH: "Ohio", PA: "Pennsylvania", SC: "South Carolina", TN: "Tennessee", TX: "Texas", VA: "Virginia", WA: "Washington" };

function displayState(value) {
  return stateNames[String(value || "").toUpperCase()] || value;
}

export function formatLocation(data) {
  const values = data?.locationLabel || [data?.city, data?.stateCode || data?.state].filter(Boolean).join(", ");
  return /^your\s+/i.test(values) ? "" : values;
}


export function googleMapsSearchUrl(address) {
  const value = String(address || "").trim();
  return value ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(value)}` : "";
}

export function programCtaName(program) {
  const name = String(program?.name || "").toLowerCase();
  const explicitStyle = String(program?.martialArtsStyle || program?.style || "").trim();
  const detectedStyle = explicitStyle || ([
    ["Brazilian jiu-jitsu", /brazilian\s+jiu|\bbjj\b|jiu[- ]?jitsu|grappl/],
    ["kickboxing", /kickbox/],
    ["boxing", /\bboxing\b/],
    ["karate", /\bkarate\b/],
    ["taekwondo", /tae?\s*kwon\s*do|taekwondo/],
    ["judo", /\bjudo\b/],
  ].find(([, pattern]) => pattern.test(name))?.[0] || "martial arts");
  const normalized = detectedStyle.toLowerCase() === "martial arts" ? "martial arts" : detectedStyle;
  if (/child|children|kid|youth/.test(name)) return normalized === "martial arts" ? "Children's martial arts" : `Children's ${normalized}`;
  if (/teen|adolescent/.test(name)) return normalized === "martial arts" ? "Teen martial arts" : `Teen ${normalized}`;
  if (/adult/.test(name)) return normalized === "martial arts" ? "Adult martial arts" : `Adult ${normalized}`;
  return normalized;
}

function createSchoolData(runtime) {
  if (!runtime) return defaultSchool;
  const business = runtime.business || {};
  const branding = runtime.branding || {};
  const configured = Boolean(runtime);
  const locationVerified = !configured || business.locationVerified === true;
  const sourceLocations = locationVerified && Array.isArray(business.locations) ? business.locations : [];
  const primaryLocation = sourceLocations[0] || {};
  const images = runtimeImages(runtime.images, configured);
  const name = business.name || runtime.name || (configured ? "" : defaultSchool.name);
  const city = locationVerified ? (business.city || primaryLocation.city || (configured ? "" : defaultSchool.city)) : "";
  const rawState = locationVerified ? (business.state || primaryLocation.state || (configured ? "" : defaultSchool.state)) : "";
  const state = displayState(rawState);
  const stateCode = locationVerified ? (business.stateCode || primaryLocation.stateCode || (rawState.length === 2 ? rawState : configured ? "" : defaultSchool.stateCode)) : "";
  const zip = locationVerified ? (business.postalCode || business.zip || primaryLocation.postalCode || (configured ? "" : defaultSchool.zip)) : "";
  const address = locationVerified ? (business.address || primaryLocation.address || (configured ? "" : defaultSchool.address)) : "";
  const addressLine = locationVerified ? (business.addressLine || primaryLocation.addressLine || (address && city ? [address, city, stateCode, zip].filter(Boolean).join(", ") : "")) : "";
  const phone = business.phone || primaryLocation.phone || (configured ? "" : defaultSchool.phone);
  const email = business.email || (configured ? "" : defaultSchool.email);
  const style = business.style || runtime.style || (configured ? "Martial Arts" : defaultSchool.style || "Martial Arts");
  const seo = { ...(configured ? {} : defaultSchool.seo), ...((locationVerified ? runtime.seo : {}) || {}) };
  const offer = { ...defaultSchool.freeWeekOffer, ...(runtime.offer || {}) };
  if (runtime.offer?.name && !runtime.offer?.title) offer.title = runtime.offer.name;
  const establishedYear = branding.establishedYear || business.establishedYear || (runtime ? null : defaultSchool.establishedYear);
  const monogram = branding.monogram || nameMonogram(name);
  const positioning = configured && !city ? `Welcoming ${style.toLowerCase()} training for students at every level.` : business.positioning || runtime.positioning || (configured ? `Welcoming ${style.toLowerCase()} training for students at every level.` : defaultSchool.positioning);
  const resolvedOffer = { ...offer, title: offer.title || offer.name || defaultSchool.freeWeekOffer.title };
  const map = locationVerified ? business.map || {} : {};
  const hasSourceHours = Array.isArray(runtime.hours) && runtime.hours.length > 0;
  const resolvedHours = hasSourceHours ? runtime.hours : (configured ? [] : defaultSchool.hours);
  const mapUrl = configured ? googleMapsSearchUrl(addressLine) : defaultSchool.mapUrl || "";
  const allPrograms = runtimePrograms(runtime.programs, images, city, state, stateCode, style, configured);
  const resolved = {
    ...defaultSchool,
    ...runtime,
    name,
    locationVerified,
    shortName: branding.shortName || name,
    style,
    tagline: business.tagline || runtime.tagline || (configured ? "" : defaultSchool.tagline),
    positioning,
    differentiators: Array.isArray(business.differentiators) ? business.differentiators : [],
    branding,
    customization: runtimeCustomization(runtime.customization),
    city,
    state,
    stateCode,
    zip,
    address,
    addressLine,
    phone,
    phoneHref: business.phoneHref || (phone ? `tel:${phone.replace(/\D/g, "")}` : ""),
    email,
    emailHref: business.emailHref || (email ? `mailto:${email}` : ""),
    mapUrl,
    mapEmbedUrl: map.embedUrl || (configured ? "" : defaultSchool.mapEmbedUrl || ""),
    mapAttribution: map.attribution || "",
    locationLabel: [city, stateCode].filter(Boolean).join(", "),
    locations: sourceLocations,
    socialLinks: runtimeSocialLinks(runtime.socialLinks),
    hours: resolvedHours,
    hoursAreDemonstration: false,
    images,
    programs: allPrograms.filter((program) => program.type !== "event"),
    offerings: allPrograms.filter((program) => program.type === "event"),
    instructors: runtimeInstructors(runtime.instructors, images, configured),
    testimonials: runtimeTestimonials(runtime.reviews, configured),
    reviewProof: runtimeReviewProof(runtime.reviews, configured),
    establishedYear,
    monogram,
    freeWeekOffer: resolvedOffer,
    seo: {
      ...seo,
      defaultTitle: seo.defaultTitle || `${name}${city ? ` | ${city}${stateCode ? `, ${stateCode}` : ""}` : ""}`,
      defaultDescription: seo.defaultDescription || `Welcoming ${style.toLowerCase()} training${city ? ` in ${city}` : ""} for kids, teens, adults, and families.`,
    },
  };
  return configured ? resolved : localizeData(resolved, { name, city, state, stateCode, establishedYear, monogram });
}

export const previewConfigMissing = typeof window !== "undefined" && window.location.pathname.startsWith("/preview/") && !window.__TFUN_SITE_CONFIG__;
const previewFallbackSchool = Object.freeze({
  name: "School preview",
  email: "",
  seo: Object.freeze({ defaultDescription: "" }),
  branding: Object.freeze({}),
  images: Object.freeze({}),
  programs: Object.freeze([]),
  instructors: Object.freeze([]),
  testimonials: Object.freeze([]),
  faqs: Object.freeze([]),
  benefits: Object.freeze([]),
  manifesto: Object.freeze([]),
  schedule: Object.freeze({ classes: Object.freeze([]), days: Object.freeze([]), categories: Object.freeze([]) }),
  socialLinks: Object.freeze([]),
  locations: Object.freeze([]),
  hours: Object.freeze([]),
});
export const school = previewConfigMissing ? previewFallbackSchool : createSchoolData(typeof window !== "undefined" ? window.__TFUN_SITE_CONFIG__ : null);

export const customizationGuide = {
  purpose: "Replace school-specific values in this file to create another local martial arts website without changing reusable components.",
  changeFirst: ["school.name", "school.city/state/address/phone/email", "school.images", "school.programs", "school.instructors", "school.testimonials", "school.faqs", "school.schedule", "school.seo"],
  reusableSurface: ["src/components/site", "src/pages", "src/services/leadService.js", "src/App.css"],
  leadIntegrationPoint: "src/services/leadService.js and backend /api/leads + /api/appointments — replace the demo database endpoints with a CRM or booking provider later.",
  analyticsIntegrationPoint: "src/services/analytics.js — connect dataLayer events to an analytics provider later.",
};
